<template>
  <div class="nav">
    <!-- <div :class="navCur === 0 ? 'nav-cur' : ''" @click="setCur(0)"><i class="el-icon-trophy"></i> 销售机会分析</div> -->
    <div :class="navCur === 1 ? 'nav-cur' : ''" @click="setCur(1)"><i class="el-icon-data-line"></i> 年度指标完成汇总</div>
    <div :class="navCur === 2 ? 'nav-cur' : ''" @click="setCur(2)"><i class="el-icon-menu"></i> 整体经营分析
      <transition name="el-zoom-in-bottom">
        <div class="sub-mune transition-box" v-if="subMune">
          <div @click="setLink(0)">整体经营目标</div>
          <div @click="setLink(1)">分解到季月度</div>
          <div @click="setLink(2)">分解到渠道</div>
          <div @click="setLink(3)">分解到产品</div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'NavStyle',
    props: ['navIndex'],
    data() {
      return {
        subMune: false,
        navCur: this.navIndex,
        pathArr: ['/reportMarket', '/other/map'],
        linkPathArr: ['/other/global', '/other/globalY', '/other/globalC', '/other/globalP'],
        status: false
      }
    },
    methods: {
      setCur(key, path) {
        this.status = key === 2 ? !this.status : false
        this.subMune = key === 2 && this.status ? true : false
        this.navCur = key
        if (key !== 2) {
          this.$router.push({
            path: this.pathArr[key]
          })
        }
      },
      setLink(key) {
        this.$router.push({
          path: this.linkPathArr[key]
        })
      }
    }
  }
</script>

<style>
  .nav {
    width: 100%;
    position: fixed;
    bottom: 0;
    display: flex;
    z-index: 9999;
  }

  .nav>div {
    width: 50%;
    text-align: center;
    line-height: 3.6rem;
    background-color: #fafafa;
    box-sizing: border-box;
    color: #646464;
    border-right: 1px solid #e5e5e5;
    position: relative;
  }

  .nav>div:last-child {
    border-right: none;
  }

  .nav>div.nav-cur {
    background-color: #24dadd;
    color: white;
  }

  .sub-mune {
    position: absolute;
    bottom: 3.6rem;
    right: 0;
    width: 100%;
    line-height: 3rem;
    background-color: white;
  }

  .sub-mune>div {
    border-bottom: 1px solid #e5e5e5;
    color: #646464;
  }

  .sub-mune>div:hover {
    background-color: #f5f5f5;
    color: #323232;
  }
</style>
